import { Link, usePageContent, useContents } from "@appiodev/xcore-client/xcore-ui";
import { Box, Button, Flex, SimpleGrid, Tag, Typography } from "@xcorejs/ui";
import NewsCard from "design-system/robe/cards/News";
import { FC } from "react";
import { News, NewsDetailPage } from "xcore/types";

import { useLayout } from "../../xcore";

const MoreNews: FC = () => {
  const [{ categories }] = usePageContent<News>();
  const [, { stringify }] = usePageContent<NewsDetailPage>();
  const [news, detailPage] = useContents<[News, NewsDetailPage]>();
  const { header, general } = useLayout();

  return (
    <Box>
      <Typography variant="h3" as="h2" textAlign="center" mb="2rem">
        {stringify(detailPage[0].values.discoverMoreNews)}
      </Typography>

      <Flex justifyContent="center" flexWrap="wrap" mb="3rem">
        {categories!["news-categories"]?.map(c => (
          <Link content={header.nav.stories} key={c.id} query={`?category=${c.id}`} variant="simple">
            <Tag key={"tag_" + c.id} variant="outline" {...TagStyle}>{stringify(c.name)}</Tag>
          </Link>
        ))}
      </Flex>

      <Flex width="100%" justifyContent="center" alignItems="center" flexDirection="column">
        {/* TODO: fetch more news */}
        <SimpleGrid
          gap="3rem"
          columns={{ _: 1, sm: 2, lg: 4 }}
          column="minmax(100px, 300px)"
          width={{ _: "auto", lg: "100%" }}
        >
          {news.slice(1).map(c => (
            <Link key={c.id} content={c}>
              <NewsCard content={c} variant="outline" />
            </Link>
          ))}

        </SimpleGrid>
        <Link content={header.nav.stories} variant="simple">
          <Button as="a" href="/news" mt={{ _: "3rem", sm: "6rem" }}>
            {stringify(general.values.readMore)}
          </Button>
        </Link>
      </Flex>
    </Box>
  );
};

export default MoreNews;

const TagStyle = {
  margin: ".5rem",
  cursor: "pointer",
  transition: "background 300ms",
  color: "#E00034",
  borderColor: "#E00034",

  _hover: {
    background: "#E00034",
    color: "#fff"
  }
};
